import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import { ResponseModel } from '../domain/authentication.model'
import { BaseGetModel } from '../domain/base-get-model'
import { CheckFileType, PurchasedTrackType } from '../types/purchased-track.type'
import { CoreEnvironmentService } from './core-environment.service'

@Injectable()
export class PurchaseService {
  baseUrl: string

  constructor(
    private http: HttpClient,
    private coreEnvironmentService: CoreEnvironmentService
  ) {
    this.baseUrl = this.coreEnvironmentService.getBaseURL()
  }

  getPurchasedBeats(): Observable<BaseGetModel<PurchasedTrackType>> {
    return this.http.get<BaseGetModel<PurchasedTrackType>>(`${this.baseUrl}/web/v1/purchases`)
  }

  checkFilesStatus(beatId: number, fileId: string, paymentId: number): Observable<ResponseModel<CheckFileType>> {
    return this.http.post<ResponseModel<CheckFileType>>(`${this.baseUrl}/web/v1/check-file`, {
      beatId,
      fileId,
      paymentId
    })
  }

  getPurchasedFiles(queryUrl) {
    return this.http.get(`${this.baseUrl}/web/v1/${queryUrl}`).pipe(
      map((res: any) => {
        return res.items[0]
      })
    )
  }

  // Для зачистки кеша на серваке, чтобы можно было многократно на  фронте тестить сценарии подготовки файлов.
  // Как  загружаются файлы... и меняются статусы...
  clearCache() {
    this.http.get('https://testbtv.ru/BeatsManagement/BeatsSales/StagingClearCache').subscribe(res => {
      // console.log('clearCache :', res);
    })
  }
}
